"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimaryKeyParser = void 0;
const dynamoDBToolboxError_js_1 = require("../../../errors/dynamoDBToolboxError.js");
const index_js_1 = require("../../../table/index.js");
const isValidPrimitive_js_1 = require("../../../utils/validation/isValidPrimitive.js");
class PrimaryKeyParser extends index_js_1.TableAction {
    constructor(table) {
        super(table);
    }
    parse(keyInput) {
        const table = this.table;
        const { partitionKey, sortKey } = table;
        const primaryKey = {};
        const partitionKeyValue = keyInput[partitionKey.name];
        if (!(0, isValidPrimitive_js_1.isValidPrimitive)({ ...partitionKey, big: true }, partitionKeyValue)) {
            throw new dynamoDBToolboxError_js_1.DynamoDBToolboxError('actions.parsePrimaryKey.invalidKeyPart', {
                message: `Invalid partition key: ${partitionKey.name}`,
                path: partitionKey.name,
                payload: {
                    expected: partitionKey.type,
                    received: partitionKeyValue,
                    keyPart: 'partitionKey'
                }
            });
        }
        primaryKey[partitionKey.name] = partitionKeyValue;
        if (sortKey === undefined) {
            return primaryKey;
        }
        const sortKeyValue = keyInput[sortKey.name];
        if (!(0, isValidPrimitive_js_1.isValidPrimitive)({ ...sortKey, big: true }, sortKeyValue)) {
            throw new dynamoDBToolboxError_js_1.DynamoDBToolboxError('actions.parsePrimaryKey.invalidKeyPart', {
                message: `Invalid sort key: ${sortKey.name}`,
                path: sortKey.name,
                payload: {
                    expected: sortKey.type,
                    received: sortKeyValue,
                    keyPart: 'sortKey'
                }
            });
        }
        primaryKey[sortKey.name] = sortKeyValue;
        return primaryKey;
    }
}
exports.PrimaryKeyParser = PrimaryKeyParser;
PrimaryKeyParser.actionName = 'parsePrimaryKey';
